import React from 'react';

import type { Widget } from './core-widget-types';

type WidgetConfigurationContextValue = {
  openEditModal: ((widget: Widget) => void) | undefined;
};

export const WidgetConfigurationContext = React.createContext<WidgetConfigurationContextValue>({
  openEditModal: undefined,
});
